import { ApiResponse, useFetch } from '@/api/useFetch';
import CONSTANTS from '@/helpers/constants';
import { ApiMethod } from '@/types/enums';
import type { IsAdminResponse } from '@/types/shared';

const { STATS } = CONSTANTS.API_ENTITY_URLS;

// noReLoginToast is only being used in router.ts
// it is because we don't want to show reLogin toast when user first open routes which dose not require a login
export const useGetIsAdmin = async (noReLoginToast?: boolean): Promise<ApiResponse<IsAdminResponse>> => {
  return useFetch(`api/${STATS}/isadmin`, {
    method: ApiMethod.Get,
    noReLoginToast,
  });
};
